import React, { useEffect } from "react";
import CardList from "../CardList";
import NoData from "../NoData";
import moment from "moment";
import { monthNavbar, allMonth } from "../data";
import {
  capitalize,
  getDayName,
  getFullWeeksStartAndEndInMonth,
} from "../../../utils/utilities";
import { useNavigate } from "react-router-dom";
import * as PageRoutes from "../../../utils/route_pages";
import * as Assets from "../../../utils/svg_assets";
import "./style.scss";

export const renderIcons = (type) => {
  switch (type) {
    case "Birthday":
      return Assets.iconGreetings;
    case "General Event":
      return Assets.iconEvents;
    case "Training Event":
      return Assets.iconEvents;
    default:
      return Assets.iconAppointments;
  }
};

const MonthPage = (p) => {
  const navigate = useNavigate();
  const {
    activeMonth,
    setActiveMonth,
    monthNow,
    activeNav,
    dataAllMonthly,
    dataEventsMonthly,
    dataAppointmentsMonthly,
    dataGreetingsMonthly,
    yearNow,
    renderMonth,
    dataDaysInWeeks,
    setDataDaysInWeeks,
  } = p;

  const listMonthly =
    activeNav === 0
      ? dataAllMonthly
      : activeNav === 1
      ? dataEventsMonthly
      : activeNav === 2
      ? dataAppointmentsMonthly
      : dataGreetingsMonthly;

  const handleClickCardList = (data) => {
    let eventType = ["General Event", "Training Event"];
    if (eventType.includes(data.type)) {
      navigate(`${PageRoutes.eventDetail}/${data.id}?type=${data.type}`);
    }
  };

  useEffect(() => {
    let getDaysWeek = getFullWeeksStartAndEndInMonth(renderMonth - 1, yearNow);
    let weekRange = [];
    for (let i = 0; i < getDaysWeek.length; i++) {
      let weekLength = getDaysWeek[i].filter(
        (a) => a.month == allMonth[renderMonth - 1]
      ).length;
      let perWeek = getDaysWeek[i].filter(
        (a) => a.month == allMonth[renderMonth - 1]
      );
      let initialData = [...listMonthly];
      let filterResult = initialData.filter(
        (a) =>
          moment(a.start).format("D") >= perWeek[0].date &&
          moment(a.start).format("D") <= perWeek[weekLength - 1].date
      );
      let rangeDate = {
        month: perWeek[0].month,
        week: i + 1,
        start: perWeek[0].date,
        end: perWeek[weekLength - 1].date,
        data: filterResult,
      };
      if (filterResult.length > 0) {
        weekRange.push(rangeDate);
      }
    }
    setDataDaysInWeeks(weekRange);
  }, [renderMonth, listMonthly]);

  const handleChangeMonth = (data) => {
    if (data + 1 == moment(new Date()).format("M")) {
      let settingDate = `${p.yearNow}-0${data + 1}-${moment(new Date()).format(
        "DD"
      )}`;
      p.setActiveDay(settingDate);
    } else {
      let settingDate = `${p.yearNow}-0${data + 1}-01`;
      p.setActiveDay(settingDate);
    }
    setActiveMonth(data);
  };
  return (
    <div className="month-page">
      <div className="month-scroll-nav">
        {monthNavbar.map((data, idx) => (
          <span
            key={idx}
            className={`list ${monthNow === data.month ? "now " : ""} ${
              activeMonth === data.month ? "active-month" : ""
            }`}
            onClick={() => handleChangeMonth(data.month)}
          >
            {data.value}
          </span>
        ))}
      </div>
      {dataDaysInWeeks &&
        dataDaysInWeeks.map((data, idx) => {
          if (data.data.length > 0) {
            return (
              <div key={idx}>
                <div className="list-grouping">
                  {data.start} - {data.end} {data.month}
                </div>
                {data.data.map((a, index) => (
                  <div className="content-body" key={index}>
                    <CardList
                      title={
                        a.type === "Birthday"
                          ? `${a.user_first_name} ${a.user_last_name}'s Birthday`
                          : a.name
                      }
                      time={
                        a.type === "Birthday"
                          ? "All Day"
                          : `${moment(a.start).format("HH:mm")} - ${moment(
                              a.end
                            ).format("HH:mm")}`
                      }
                      icons={renderIcons(a.type)}
                      date={`${moment(a.start).format("D")} ${capitalize(
                        getDayName(a.start)
                      )}`}
                      onClick={() => handleClickCardList(a)}
                    />
                  </div>
                ))}
              </div>
            );
          }
        })}

      {dataDaysInWeeks.length < 1 && <NoData {...p} />}
    </div>
  );
};

export default MonthPage;
